import React from 'react';

const ToastAlert = ({ 
  show, 
  message, 
  type = 'success', 
  icon = null, 
  duration = 3000, 
  onClose,
  position = 'top-right'
}) => {
  // Auto-hide functionality
  React.useEffect(() => {
    if (show && duration > 0) {
      const timer = setTimeout(() => {
        if (onClose) onClose();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [show, duration, onClose]);

  if (!show) return null;

  // Alert type configurations
  const alertConfig = {
    success: {
      className: 'alert-success',
      defaultIcon: 'fas fa-check-circle',
      ariaLabel: 'Success alert'
    },
    error: {
      className: 'alert-danger',
      defaultIcon: 'fas fa-exclamation-circle',
      ariaLabel: 'Error alert'
    },
    warning: {
      className: 'alert-warning',
      defaultIcon: 'fas fa-exclamation-triangle',
      ariaLabel: 'Warning alert'
    },
    info: {
      className: 'alert-info',
      defaultIcon: 'fas fa-info-circle',
      ariaLabel: 'Info alert'
    }
  };

  const config = alertConfig[type] || alertConfig.success;
  const displayIcon = icon || config.defaultIcon;

  // Position styles
  const positionStyles = {
    'top-right': {
      top: '20px',
      right: '20px'
    },
    'top-left': {
      top: '20px',
      left: '20px'
    },
    'top-center': {
      top: '20px',
      left: '50%',
      transform: 'translateX(-50%)'
    },
    'bottom-right': {
      bottom: '20px',
      right: '20px'
    },
    'bottom-left': {
      bottom: '20px',
      left: '20px'
    },
    'bottom-center': {
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)'
    }
  };

  return (
    <div 
      className={`alert ${config.className} alert-dismissible fade show position-fixed`}
      style={{
        ...positionStyles[position],
        zIndex: 999999,
        minWidth: '200px',
        maxWidth: '400px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px'
      }}
      role="alert"
      aria-label={config.ariaLabel}
    >
      <div className="d-flex align-items-center">
        {displayIcon && (
          <i className={`${displayIcon} me-2`} aria-hidden="true"></i>
        )}
        <span className="flex-grow-1">{message}</span>
        {onClose && (
          <button
            type="button"
            className="btn-close ms-2"
            onClick={onClose}
            aria-label="Close alert"
            style={{ fontSize: '0.8em' }}
          ></button>
        )}
      </div>
    </div>
  );
};

export default ToastAlert;
